import { createFileRoute, redirect } from '@tanstack/react-router'
import { useAuthStore } from '@/features/auth'
import { Users } from '@/features/users'

export const Route = createFileRoute('/_authenticated/users/')({
  beforeLoad: () => {
    const { auth } = useAuthStore.getState()
    if (auth.user?.role !== 'admin' && auth.user?.role !== 'super_admin') {
      throw redirect({
        to: '/403',
      })
    }
  },
  component: Users,
})
